import { MenuItemData } from '@cue/molecules';
import { Link } from 'gatsby';

interface MenuItemDataExtended {
  onCustomAction?(custom_action: string): void;
  custom_action?: string;

  onClick?(): void;
}
export const FooterMenuItem: React.FC<MenuItemDataExtended & MenuItemData> = (props) => {
  const { label, link, isActive, target, custom_action, onCustomAction } = props;
  const ariaLabel = !label ? 'Home' : label ? label : 'menu-item';

  if (target === '_blank') {
    return (
      <a href={link || '/'} target={target} aria-label={ariaLabel}>
        {label}
      </a>
    );
  }
  if (custom_action) {
    return (
      <a
        onClick={(e) => {
          e.preventDefault();
          onCustomAction && onCustomAction(custom_action);
        }}
        aria-label={ariaLabel}>
        {label}
      </a>
    );
  }

  if (target) {
    return (
      <a href={link || ''} target={target || undefined} aria-label={ariaLabel}>
        {label}
      </a>
    );
  }

  return (
    <Link
      to={link || '/'}
      target={target}
      aria-label={ariaLabel}
      activeClassName="active"
      partiallyActive={isActive}>
      {label}
    </Link>
  );
};
